import { render, staticRenderFns } from "./fluxMonitor.vue?vue&type=template&id=3db164ee&scoped=true&"
import script from "./fluxMonitor.vue?vue&type=script&lang=js&"
export * from "./fluxMonitor.vue?vue&type=script&lang=js&"
import style0 from "./fluxMonitor.vue?vue&type=style&index=0&id=3db164ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db164ee",
  null
  
)

export default component.exports